<template>

</template>

<script>
export default {
  name: "Logs"
}
</script>

<style scoped>

</style>